<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/businessman.svg" style="width:20px" /> Container Master
          </p>
        </CCardHeader>
<c-card-body>
        <CDataTable
          :items="containerItem"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="10"
        
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        />
      </c-card-body>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/businessman.svg" style="width:20px" /> Container Master Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput label="Container Code" horizontal autocomplete="name" v-model="conCode" />

            <CInput label="Container Name" horizontal autocomplete="name" v-model="conName" />

            <CInput label="Container Model" horizontal autocomplete="name" v-model="conModel" />
            <div class="row">
              <div class="col-sm-4">Container Size</div>
              <div class="col-sm-8">
                <Vselect :options="option" v-model="conSize" searchable />
              </div>
            </div>
            <br />
            <CInput label="Company" horizontal autocomplete="name" v-model="company" />
            <CInput label="Capacity(L)" horizontal autocomplete="name" v-model="capacity" />
            <CInput
              label="	
Threshold level(L)"
              horizontal
              autocomplete="name"
              v-model="threshold"
            />
            <CInput label="	
Maximum Straw
" horizontal autocomplete="name" v-model="maximumStraw" />

            <CInput label="Date" type="date" horizontal v-model="date" />
            <CInput
              label="Evaporation rate L / day"
              horizontal
              autocomplete="name"
              v-model="evaporationRate"
            />
            <CInput label="Goblet Level" horizontal autocomplete="name" v-model="gobletLevel" />
            <CInput label="Ln2 Stock (L)" horizontal autocomplete="name" v-model="ln2Stock" />
            <CRow>
              <CCol sm="3">
                <h5 style="font-size:15px">Status</h5>
              </CCol>
              <CCol sm="3">
                <CSwitch
                  class="mx-1"
                  color="primary"
                  v-model="suspend"
                  checked
                  variant="opposite"
                  style="width:50px;float:left !important"
                  shape="pill"
                  v-bind="labelTxt"
                />
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addZone">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateZone">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteZone">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addZone">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="secondary" style="width:100px" v-if="cancelButton" @click="CancelZone">
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>&nbsp;
          <CButton color="info" v-if="addnewButton" @click="addZoneplus">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import DatePicker from "vue2-datepicker";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
import { Vselect } from "@/components";
export default {
  components: { CTableWrapper, DatePicker, Vselect },

  data() {
    return {
        labelTxt: {
        labelOn: 'yes',
        labelOff: 'no'
      },
      option: [1, 2, 3, 4, 5, 6],
      containerItem: [],
      editContainer: [],
      conCode: null,
      conName: "",
      conModel: "",
      conSize: "",
      company: "",
      capacity: "",
      threshold: "",
      maximumStraw: "",
      date: "",
      evaporationRate: "",
      gobletLevel: "",
      ln2Stock: "",
      suspend: "",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      fields: [
        {
          key: "conCode",
          sortable: true
        },
        {
          key: "conName",
          sortable: true
        },

        {
          key: "conModel",
          sortable: true
        },
        {
          key: "conSize",
          sortable: true
        },
        {
          key: "company",
          sortable: true
        }
      ]
    };
  },
  methods: {
    getcontainermasterList() {
      APIService.containermasterList().then(res => {
        if (res.status == 200) {
          this.containerItem = res.data;

          this.conCode =  this.containerItem[0].conCode;
      this.conName = this.containerItem[0].conName;
      this.conModel = this.containerItem[0].conModel;
      this.conSize = this.containerItem[0].conSize;
      this.company = this.containerItem[0].company;
      this.capacity = this.containerItem[0].capacity;
      this.threshold = this.containerItem[0].threshold;
      this.maximumStraw = this.containerItem[0].maximumStraw;
      this.date = this.containerItem[0].date;
      this.evaporationRate = this.containerItem[0].evaporationRate;
      this.gobletLevel = this.containerItem[0].gobletLevel;
      this.ln2Stock = this.containerItem[0].ln2Stock;
      this.suspend = this.containerItem[0].suspend;
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);
      this.editContainer = item;
      this.conCode = item.conCode;
      this.conName = item.conName;
      this.conModel = item.conModel;
      this.conSize = item.conSize;
      this.company = item.company;
      this.capacity = item.capacity;
      this.threshold = item.threshold;
      this.maximumStraw = item.maximumStraw;
      this.date = item.date;
      this.evaporationRate = item.evaporationRate;
      this.gobletLevel = item.gobletLevel;
      this.ln2Stock = item.ln2Stock;
      this.suspend = item.suspend;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addZone() {
      let conCode = this.conCode;
      let conName = this.conName;
      let conModel = this.conModel;
      let conSize = this.conSize;
      let company = this.company;
      let capacity = this.capacity;
      let threshold = this.threshold;
      let maximumStraw = this.maximumStraw;
      let date = this.date;
      let evaporationRate = this.evaporationRate;
      let gobletLevel = this.gobletLevel;
      let ln2Stock = this.ln2Stock;
      let suspend = this.suspend;
      let data = {
        conCode,
        conName,
        conModel,
        conSize,
        company,
        capacity,
        threshold,
        maximumStraw,
        date,
        evaporationRate,
        gobletLevel,
        ln2Stock,
        suspend
      };
      APIService.saveContainermaster(data).then(res => {
        if (res.status == 200) {
          this.conCode = null;
          this.conName = "";
          this.conModel = "";
          this.conSize = "";
          this.company = "";
          this.capacity = "";
          this.threshold = "";
          this.maximumStraw = "";
          this.date = "";
          this.evaporationRate = "";
          this.gobletLevel = "";
          this.ln2Stock = "";
          this.suspend = "";

          this.getcontainermasterList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    addZoneplus() {
      this.conCode = null;
          this.conName = "";
          this.conModel = "";
          this.conSize = "";
          this.company = "";
          this.capacity = "";
          this.threshold = "";
          this.maximumStraw = "";
          this.date = "";
          this.evaporationRate = "";
          this.gobletLevel = "";
          this.ln2Stock = "";
          this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getcontainermasterList();
    },

    CancelZone() {
      this.conCode = null;
          this.conName = "";
          this.conModel = "";
          this.conSize = "";
          this.company = "";
          this.capacity = "";
          this.threshold = "";
          this.maximumStraw = "";
          this.date = "";
          this.evaporationRate = "";
          this.gobletLevel = "";
          this.ln2Stock = "";
          this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false),this.getcontainermasterList();
    },
    updateZone() {
      let id = this.editContainer._id;
      let conCode = this.conCode;
      let conName = this.conName;
      let conModel = this.conModel;
      let conSize = this.conSize;
      let company = this.company;
      let capacity = this.capacity;
      let threshold = this.threshold;
      let maximumStraw = this.maximumStraw;
      let date = this.date;
      let evaporationRate = this.evaporationRate;
      let gobletLevel = this.gobletLevel;
      let ln2Stock = this.ln2Stock;
      let suspend = this.suspend;
      let value = {
        conCode,
        conName,
        conModel,
        conSize,
        company,
        capacity,
        threshold,
        maximumStraw,
        date,
        evaporationRate,
        gobletLevel,
        ln2Stock,
        suspend
      };
      let data = { id, value };
      APIService.containermasterUpdate(data).then(res => {
        if (res.status == 200) {
          this.conCode = null;
          this.conName = "";
          this.conModel = "";
          this.conSize = "";
          this.company = "";
          this.capacity = "";
          this.threshold = "";
          this.maximumStraw = "";
          this.date = "";
          this.evaporationRate = "";
          this.gobletLevel = "";
          this.ln2Stock = "";
          this.suspend = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getcontainermasterList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    deleteZone() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    delete() {
      let id = this.editContainer._id;
      let data = { id };
      APIService.containermasterDelete(data).then(res => {
        if (res.status == 200) {
         this.conCode = null;
          this.conName = "";
          this.conModel = "";
          this.conSize = "";
          this.company = "";
          this.capacity = "";
          this.threshold = "";
          this.maximumStraw = "";
          this.date = "";
          this.evaporationRate = "";
          this.gobletLevel = "";
          this.ln2Stock = "";
          this.suspend = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getcontainermasterList();
        }
      });
    }
  },
  created() {
    // this.getBreedList();
    this.getcontainermasterList();
  }
};
</script>
